import { TThunkAction } from '../../types/redux/thunk';
import { TCompareType } from '../../types/compareType';
import { resolveCompare } from '../../services/compare';
import { getComparisonFailed, getComparisonLoading, getComparisonSucceed } from './getComparisonActions';

export interface IParameters {
  compareType: TCompareType;
}

export function getComparison({ compareType }: IParameters): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    dispatch(getComparisonLoading(compareType));

    try {
      const compare = await resolveCompare(context, { compareType });

      dispatch(getComparisonSucceed({ ...compare, compareType }));
    } catch (err) {
      dispatch(getComparisonFailed(compareType));
    }
  };
}
